import { useEffect, useState } from 'react'
import moment from 'moment-timezone'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'

import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { MultiSectionDigitalClock } from '@mui/x-date-pickers/MultiSectionDigitalClock'

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'

const Expiry = ({ open, setOpen, expiryDate, setExpiryDate }) => {

  const [newExpiry, setNewExpiry] = useState(expiryDate)
  const expiryMoment = value => {
    const parsed = moment(value, [moment.ISO_8601, "YYYYMMDDHHmmss"], true)
    return parsed.isValid() ? parsed : moment()
  }

  const setExpiry = date => {
    setNewExpiry(date.format())
  }

  const saveExpiryDate = () => {
    setExpiryDate(newExpiry)
    close()
  }

  useEffect(() => {
    setNewExpiry(expiryDate)
  },[expiryDate])

  const close = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Set Expiry Date
      </DialogTitle>

      <DialogContent>
        <div className='flex flex-row gap-20'>
          <div><DateCalendar minDate={moment()} value={expiryMoment(newExpiry)} onChange={setExpiry} /></div>
          <div><MultiSectionDigitalClock ampm={false} timeSteps={{ hours: 1, minutes: 1 }} value={expiryMoment(newExpiry)} onChange={setExpiry} /></div>
        </div>
      </DialogContent>

      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close}>Cancel</Button>
          <Button variant="contained" onClick={saveExpiryDate} autoFocus disabled={expiryMoment(newExpiry).isSame(expiryMoment(expiryDate))}><CalendarMonthOutlinedIcon className="mr-5" />Set expiry date</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default Expiry
